var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessModalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55 4C82.9581 4 105.661 26.7026 105.661 54.6606C105.661 82.6187 82.9581 105.321 55 105.321C27.0419 105.321 4.33936 82.6187 4.33936 54.6606C4.33936 26.7026 27.0419 4 55 4Z",
    stroke: "url(#paint0_linear_403_2741)",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5 41.3633L48.9057 67.9577L34.5004 53.5524",
    stroke: "url(#paint1_linear_403_2741)",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_403_2741",
    x1: 20.6258,
    y1: -96.2027,
    x2: 5.00192,
    y2: 78.341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CEA6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F984F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_403_2741",
    x1: 42.1086,
    y1: 17.9602,
    x2: 39.6318,
    y2: 60.6176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CEA6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F984F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessModalIcon);
export default __webpack_public_path__ + "static/media/success-modal-icon.12c5c58134b3cf678756789483b9f53e.svg";
export { ForwardRef as ReactComponent };